import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { CreditReport } from "./types";
import { GlobalState } from "../store";

const initialState = {
  viewId3d: "",
  view2dInventoryId: "",
  hoveredInventorySection: "",
};

export const seatMapState = createSlice({
  name: "seatMap",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Partial<typeof initialState>>) => {
      if (action.payload.viewId3d !== undefined) {
        state.viewId3d = action.payload.viewId3d;
      }
      if (action.payload.hoveredInventorySection !== undefined) {
        state.hoveredInventorySection = action.payload.hoveredInventorySection;
      }
      if (action.payload.view2dInventoryId !== undefined) {
        state.view2dInventoryId = action.payload.view2dInventoryId;
      }
    },
  },
});

const selector = (state: GlobalState) => state.data.seatMap;
export const selectViewId3d = createSelector(selector, (s) => s.viewId3d);
export const selectHoveredInventorySection = createSelector(
  selector,
  (s) => s.hoveredInventorySection
);
export const selectView2dInventoryId = createSelector(
  selector,
  (s) => s.view2dInventoryId
);
